import { createContext, RefObject } from 'react';
import { Scrollbars } from '../../typings/react-custom-scrollbars';
import { Location } from 'react-router-dom';
import { MODAL, OVERLAY, SIDEBAR } from './ui-constants';

export type ContextKey = typeof SIDEBAR | typeof OVERLAY | typeof MODAL;

export type Context = {
	key: ContextKey;
	paths: string[];
	routesMatcher: (paths: string[]) => (value: string) => boolean;
	queryEncoder: (params: { location: string | Location; to: string }, oldLocation?: Location) => string | Location;
	queryDecoder: (value: string | Location) => Location;
};

export type UIContextType = {
	hasSidebar: boolean;
	hasHeader: boolean;
	hasSmallerBrandingHeader: boolean;
	hasSubHeader: boolean;
	hasSmallSubHeader: boolean;
	hasSearchBar: boolean;
	hasStaticHeader: boolean;
	hasProductNav: boolean;
	hasHeroHeader: boolean;
	hasHeroBlurred: boolean;
	hasMainBlurred: boolean;
	hasNotificationPopupsBlurred: boolean;
	hasFooter: boolean;
	hasOverlay: boolean;
	hasAppBanner: boolean;
	showSidebar: boolean;
	showOverlay: boolean;
	withinSidebar: boolean;
	within: string;
	scrollbar?: RefObject<Scrollbars | null>;
	nativeComponentEnabled: boolean;
	sidebarAnimationEnabled: boolean;
	hasTopNavigation: boolean;
	contexts: Context[];
};

const UIContext = createContext<UIContextType>({
	hasSidebar: false,
	hasHeader: false,
	hasSmallerBrandingHeader: false,
	hasSubHeader: false,
	hasSmallSubHeader: false,
	hasSearchBar: false,
	hasStaticHeader: false,
	hasProductNav: false,
	hasHeroHeader: false,
	hasHeroBlurred: false,
	hasMainBlurred: false,
	hasNotificationPopupsBlurred: false,
	hasFooter: false,
	hasOverlay: false,
	hasAppBanner: false,
	showSidebar: false,
	showOverlay: false,
	withinSidebar: false, // TODO Consider removing
	within: '',
	scrollbar: undefined,
	nativeComponentEnabled: false,
	sidebarAnimationEnabled: false,
	hasTopNavigation: false,
	contexts: []
});
export default UIContext;
